"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _styledContentBanner = require("./styled-content-banner-2");
var _excluded = ["className", "variant", "textContent", "link", "dataTestId", "dataAnalyticsId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var defaultProps = {
  className: undefined,
  dataTestId: undefined,
  dataAnalyticsId: undefined,
  link: {
    href: undefined,
    onClick: function onClick() {},
    text: undefined
  },
  textContent: {
    enhancedText: undefined,
    heading: undefined,
    headingTag: 'h2',
    legalText: undefined,
    paragraph: undefined,
    subHeading: undefined,
    subHeadingTag: 'h3'
  },
  variant: 'brand'
};
var propTypes = {
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  dataAnalyticsId: _propTypes["default"].string,
  link: _propTypes["default"].shape({
    href: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].string
  }),
  textContent: _propTypes["default"].shape({
    enhancedText: _propTypes["default"].string,
    heading: _propTypes["default"].string,
    headingTag: _propTypes["default"].string,
    legalText: _propTypes["default"].string,
    paragraph: _propTypes["default"].string,
    subHeading: _propTypes["default"].string,
    subHeadingTag: _propTypes["default"].string
  }),
  variant: _propTypes["default"].oneOf(['brand', 'black', 'blackWithBorder'])
};
var enhanceText = function enhanceText(heading, enhancedText) {
  return heading.split(' ').map(function (word) {
    return word === enhancedText ? "<span class=\"fuse-content-banner-2__enhanced-text\" data-testid=\"fuse-content-banner-2-enhanced-text-test-id\">&nbsp;".concat(word, "&nbsp;</span>") : word;
  }).join(' ');
};
function ContentBanner2(_ref) {
  var className = _ref.className,
    variant = _ref.variant,
    textContent = _ref.textContent,
    link = _ref.link,
    dataTestId = _ref.dataTestId,
    dataAnalyticsId = _ref.dataAnalyticsId,
    props = _objectWithoutProperties(_ref, _excluded);
  var headingTag = textContent.headingTag,
    heading = textContent.heading,
    enhancedText = textContent.enhancedText,
    subHeading = textContent.subHeading,
    subHeadingTag = textContent.subHeadingTag,
    paragraph = textContent.paragraph,
    legalText = textContent.legalText;
  var isValidCTA = !!link.href || !!link.onClick;
  return /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledContentBanner, _extends({
    variant: variant,
    className: className,
    "data-testid": dataTestId || 'fuse-content-banner-2-test-id',
    "data-analyticsid": dataAnalyticsId,
    as: isValidCTA && (link.href ? 'a' : 'button'),
    href: link.href,
    onClick: !link.href ? link.onClick : undefined
  }, props), /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledText, {
    variant: variant
  }, heading && /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledHeading, {
    size: {
      xxs: '7',
      m: '8',
      l: '10'
    },
    tag: headingTag,
    type: "display"
  }, enhancedText ? /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledHeadingSpan, {
    variant: variant
    // eslint-disable-next-line react/no-danger
    ,

    dangerouslySetInnerHTML: {
      __html: enhancedText ? enhanceText(heading, enhancedText) : heading
    }
  }) : heading), /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledTextWrapper, null, subHeading && /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledSubHeading, {
    size: {
      xxs: '3',
      l: '4'
    },
    tag: subHeadingTag,
    type: "heading",
    variant: variant
  }, subHeading), paragraph && /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledParagraph, {
    size: "1",
    tag: "p",
    type: "paragraph",
    variant: variant,
    "data-testid": "fuse-content-banner-2-paragraph-test-id",
    className: "fuse-content-banner-2__paragraph"
  }, paragraph), legalText && /*#__PURE__*/_react["default"].createElement(_styledContentBanner.StyledParagraph, {
    size: "m2",
    tag: "p",
    type: "paragraph",
    variant: variant,
    "data-testid": "fuse-content-banner-2-legal-text-test-id",
    className: "fuse-content-banner-2__legal-text"
  }, legalText))), (link.href || link.onClick) && link.text && /*#__PURE__*/_react["default"].createElement(_buttons.SpanButton, {
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    variant: "tertiary",
    "data-testid": "fuse-content-banner-2-span-button-test-id",
    className: "fuse-content-banner-2__span-button fuse-span-button"
  }, link.text));
}
ContentBanner2.propTypes = propTypes;
ContentBanner2.defaultProps = defaultProps;
ContentBanner2.displayName = 'ContentBanner2';
var _default = exports["default"] = ContentBanner2;